/** Returns the container + text style for a status pill cell. */
export const getStatusStyle = (status: string, isDark: boolean = false) => {
  const normalizedStatus = status
    ?.toString()
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, " ");

  const base = {
    container: {
      height: 24,
      paddingHorizontal: 8,
      paddingVertical: 2,
      borderRadius: 4,
      alignItems: "center" as const,
      justifyContent: "center" as const,
      overflow: "hidden" as const,
      flexDirection: "row" as const,
      alignSelf: "flex-start" as const,
      minWidth: 80,
      maxWidth: 200,
    },
    text: {
      fontWeight: "600" as const,
      fontSize: 12,
      textAlign: "center" as const,
      lineHeight: 16,
    },
  };

  if (isDark) {
    switch (normalizedStatus) {
      case "in progress":
        return {
          container: { ...base.container, backgroundColor: "rgba(217,150,0,0.22)" },
          text: { ...base.text, color: "#FFD166" },
        };
      case "completed":
      case "complete":
        return {
          container: { ...base.container, backgroundColor: "rgba(56,182,56,0.22)" },
          text: { ...base.text, color: "#8FEBA8" },
        };
      case "active":
        return {
          container: { ...base.container, backgroundColor: "rgba(61,139,255,0.22)" },
          text: { ...base.text, color: "#99CFFF" },
        };
      case "enabled":
        return {
          container: { ...base.container, backgroundColor: "rgba(56,182,56,0.22)" },
          text: { ...base.text, color: "#8FEBA8" },
        };
      case "disabled":
        return {
          container: { ...base.container, backgroundColor: "rgba(176,176,176,0.18)" },
          text: { ...base.text, color: "#D4D4D4" },
        };
      default:
        return {
          container: { ...base.container, backgroundColor: "rgba(217,150,0,0.22)" },
          text: { ...base.text, color: "#FFD166" },
        };
    }
  }

  switch (normalizedStatus) {
    case "in progress":
      return {
        container: { ...base.container, backgroundColor: "#E5A408" },
        text: { ...base.text, color: "#000000" },
      };
    case "completed":
    case "complete":
      return {
        container: { ...base.container, backgroundColor: "#027C06" },
        text: { ...base.text, color: "#000000" },
      };
    case "active":
      return {
        container: { ...base.container, backgroundColor: "#005CBC" },
        text: { ...base.text, color: "#000000" },
      };
    case "enabled":
      return {
        container: { ...base.container, backgroundColor: "rgb(202, 243, 198)" },
        text: { ...base.text, color: "#0C420B" },
      };
    case "disabled":
      return {
        container: { ...base.container, backgroundColor: "rgb(230, 230, 230)" },
        text: { ...base.text, color: "#6B6B6B" },
      };
    default:
      return {
        container: { ...base.container, backgroundColor: "#E5A408" },
        text: { ...base.text, color: "#000000" },
      };
  }
};
